module.exports = __webpack_public_path__ + "img/early-warning-arm.6182326e.svg";